import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

// Register Chart.js components globally
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

import { awsConfig } from './config/aws-config';
import Header from './components/Header';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

// Lazy load pages for code splitting
const Dashboard = lazy(() => import('./pages/Dashboard'));
const HealthData = lazy(() => import('./pages/HealthData'));
const WorkoutPlanning = lazy(() => import('./pages/WorkoutPlanning'));
const DailyWorkout = lazy(() => import('./pages/DailyWorkout'));
const WorkoutHistory = lazy(() => import('./pages/WorkoutHistory'));
const Account = lazy(() => import('./pages/Account'));

// Configure Amplify
Amplify.configure(awsConfig);

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
);

function App() {
  return (
    <Authenticator>
      {({ signOut, user }) => (
        <Router>
          <div className="min-h-screen flex flex-col">
            <Header />
            <Navigation user={user} signOut={signOut} />
            
            <main className="flex-1">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <Suspense fallback={<PageLoader />}>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/health" element={<HealthData />} />
                    <Route path="/planning" element={<WorkoutPlanning />} />
                    <Route path="/workout" element={<DailyWorkout />} />
                    <Route path="/history" element={<WorkoutHistory />} />
                    <Route path="/account" element={<Account user={user} signOut={signOut} />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Suspense>
              </div>
            </main>
            
            <Footer />
          </div>
        </Router>
      )}
    </Authenticator>
  );
}

export default App;
